module.exports = __webpack_public_path__ + "img/full-11.46572b4d.png";